import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JwtService } from '../jwt.service';
import { NumberUtils } from '../utils/utils/number-utils';
import { ConfigService } from './config.service';
import { CartSingletonService } from '../singletons/cart-singleton.service';
import { ClienteSingletonService } from '../singletons/cliente-singleton.service';
import { ItemDetalhado } from '../persistences/item-detalhado';

@Injectable({
    providedIn: 'root'
})
export class ItemService {

    idsItensNoCarrinho = [];

    constructor(
        private configService: ConfigService,
        private httpClient: HttpClient,
        private jwtService: JwtService,
        private clienteSingletonService: ClienteSingletonService,
        private cartSingletonService: CartSingletonService
    ) {

    }

    getImagem(id_item: number, principal: boolean) {

        this.jwtService.validarAcessToken();

        let httpParams = new HttpParams();
        httpParams = httpParams
            .append('id', id_item.toString())
            .append('principal', String(principal));
        return this.httpClient.get(
            this.configService.getEndereco() + '/ProdutoFoto/getImgsById',
            {
                headers: this.configService.getHeaders(),
                params: httpParams
            }
        )
    }


    getItemDetalhes(id_item: number) {

        this.jwtService.validarAcessToken();

        let httpParams = new HttpParams();
        httpParams = httpParams
            .append('id', NumberUtils.numberToString(id_item))
            .append('cdFilial', NumberUtils.numberToString(this.clienteSingletonService.getClienteEstatico().getClienteFilial.getCdFilial));

        return this.httpClient.get(
            this.configService.getEndereco() + '/Produto/getById',
            {
                headers: this.configService.getHeaders(),
                params: httpParams
            }
        )
    }

    getSimilares(id_item: number) {

        this.jwtService.validarAcessToken();

        let httpParams = new HttpParams();
        const carrinho = this.cartSingletonService.getCarrinhoEstatico();
        httpParams = httpParams
            .append('item', NumberUtils.numberToString(id_item))
            .append('cdFormaPagamento', this.cartSingletonService.getFormaECondicaoDePagamento().cdFormaPgto)
            .append('cdCondPgto', this.cartSingletonService.getFormaECondicaoDePagamento().cdCondPgto)
            .append('tipoFrete', carrinho.getTpFrete);
        return this.httpClient.get(
            this.configService.getEndereco() + '/Business/Similares/getByItem',
            {
                headers: this.configService.getHeaders(),
                params: httpParams
            }
        )
    }

    getInfoVeiculo(id_item: number) {

        this.jwtService.validarAcessToken();

        let httpParams = new HttpParams();
        httpParams = httpParams
            .append('id_item', NumberUtils.numberToString(id_item));

        return this.httpClient.get(
            this.configService.getEndereco() + '/ProdutoVeiculo/getDetalhadoById',
            {
                headers: this.configService.getHeaders(),
                params: httpParams
            }
        )
    }

    getPoliticaDesconto(item: ItemDetalhado ) {
        this.jwtService.validarAcessToken();

        let httpParams = new HttpParams();
        const isItemNoCarrinho = this.cartSingletonService.itemEstaNoCarrinho(item);

        const tabela = item.itemDetalhes.outrosPrecos.find((p) => {
            return p.idGeral === item.itemPedido.idTabelaPreco
        }).cdTabelaPreco;

        const cliente = this.clienteSingletonService.getClienteEstatico();
        const carrinho = this.cartSingletonService.getCarrinhoEstatico();
        httpParams = httpParams.append('data', new Date().toLocaleDateString('pt-BR'));
        httpParams = httpParams.append('cdCliente', cliente.getCdCliente.toString());
        httpParams = httpParams.append('filial', cliente.getClienteFilial.getCdFilial);
        httpParams = httpParams.append('cdFormaPagamento', carrinho.getCdFormaPgto.toString());
        httpParams = httpParams.append('cdCondPgto', carrinho.getCdCondPgto.toString());
        httpParams = httpParams.append('origemPedido', '0');
        httpParams = httpParams.append('funcionario', cliente.getCdFuncionario);
        httpParams = httpParams.append('idItem', item.itemDetalhes.idItem);
        httpParams = httpParams.append('un', isItemNoCarrinho? item.itemPedido.unMedVenda : item.itemDetalhes.unMedEstoque);
        httpParams = httpParams.append('qtd', item.itemPedido.quantidade);
        httpParams = httpParams.append('cdTabela', isItemNoCarrinho? tabela : item.itemDetalhes.tabelaPrecoView.cdTabelaPreco);
        httpParams = httpParams.append('tipoFrete', carrinho.getTpFrete);
        return this.httpClient.get(
            this.configService.getEndereco() + '/PrecoProduto/getPoliticaDesconto',
            {
                headers: this.configService.getHeaders(),
                params: httpParams
            }
        );
    }

}
